import { gql } from 'apollo-angular';

export const QueryProjectClassificationRate = gql`
  query projectWages(
    $skip: Int
    $take: Int
    $tenantId: UUID!
    $where: ProjectClassificationRateFilterInput
    $order: [ProjectClassificationRateSortInput!]
  ) {
    projectClassificationRates(
      skip: $skip
      take: $take
      tenantId: $tenantId
      where: $where
      order: $order
    ) {
      totalCount
      items {
        classificationRateId
        createdBy
        createdDate
        id
        legacyProjectId
        modifiedBy
        modifiedDate
        projectId
        tenantId
        classificationRate {
          trainingType
          constructionTypeId
          craftClassificationId
          createdBy
          createdDate
          expirationDate
          id
          issueDate
          jurisdictionLocationId
          modifiedBy
          modifiedDate
          ownerTenantId
          publicationDate
          wageDeterminationModificationId
          wageRateShiftTypeId
          wageRateStatusTypeId
          wageRateTypeId
          craftClassification {
            craftId
            createdBy
            createdDate
            id
            jurisdictionId
            modifiedBy
            modifiedDate
            name
            classificationRates {
              constructionTypeId
              craftClassificationId
              createdBy
              createdDate
              expirationDate
              id
              issueDate
              jurisdictionLocationId
              modifiedBy
              modifiedDate
              ownerTenantId
              publicationDate
              wageDeterminationModificationId
              wageRateShiftTypeId
              wageRateStatusTypeId
              wageRateTypeId
            }
            craft {
              createdBy
              createdDate
              id
              jurisdictionId
              modifiedBy
              modifiedDate
              name
            }
            jurisdiction {
              createdBy
              createdDate
              id
              isFhwa
              jurisdictionScenarioId
              jurisdictionTypeId
              modifiedBy
              modifiedDate
              name
              wageModificationTypeId
              wageRateTemplateTypeId
              wageRateTemplateType {
                name
                rateTemplateType
              }
            }
          }
          constructionType {
            createdBy
            createdDate
            description
            id
            isDefault
            isReadOnly
            jurisdictionId
            modifiedBy
            modifiedDate
            name
          }
          projectClassificationRates {
            classificationRateId
            createdBy
            createdDate
            id
            legacyProjectId
            modifiedBy
            modifiedDate
            projectId
            tenantId
          }
          wageDeterminationModification {
            createdBy
            createdDate
            id
            jurisdictionId
            modifiedBy
            modifiedDate
            name
            wageDeterminationId
            wageDetermination {
              createdBy
              createdDate
              id
              jurisdictionId
              modifiedBy
              modifiedDate
              name
            }
          }
          wageRate {
            baseFringeRate
            baseWageRate
            notes
            standardHoursDay
            totalDoubletimeRate
            totalHourlyRate
            totalOvertimeRate
            extendedWageRate {
              doubletimeBaseRate
              doubletimeFringeRate
              firstShiftBaseRate
              holidayFringeRate
              overtimeBaseRate
              overtimeFringeRate
              saturdayBaseRate
              saturdayFringeRate
              standardHoursWeek
              sundayBaseRate
              sundayFringeRate
              totalSaturdayRate
              totalSundayRate
            }
            trainingRate
            footNotes {
              amount
              code
              description
              name
            }
          }
          wageRateShiftType {
            createdBy
            createdDate
            id
            modifiedBy
            modifiedDate
            name
          }
          wageRateStatusType {
            createdBy
            createdDate
            id
            modifiedBy
            modifiedDate
            name
            rateStatusType
          }
          wageRateType {
            createdBy
            createdDate
            id
            modifiedBy
            modifiedDate
            name
            rateType
          }
          jurisdictionLocation {
            createdBy
            createdDate
            id
            jurisdictionId
            modifiedBy
            modifiedDate
            wageLocation {
              name
              id
            }
            wageLocationId
            jurisdiction {
              createdBy
              createdDate
              id
              isFhwa
              jurisdictionScenarioId
              jurisdictionTypeId
              modifiedBy
              modifiedDate
              name
              wageModificationTypeId
              wageRateTemplateTypeId
              wageRateTemplateType {
                name
                rateTemplateType
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
